export default __webpack_public_path__ + "static/media/userAttributes.429c44a5.svg";